/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import nbrApi from '../../../services/nbrApi';
import { useNavigate, useParams } from 'react-router-dom';

// Validation schema
const validationSchema = Yup.object().shape({
    property: Yup.string().required('Property is required'),
    roomType: Yup.string().required('Room Type is required'),
    workStages: Yup.string().required('Work Stages is required'),
    taskProcess: Yup.string().required('Task Process is required'),
    taskGroups: Yup.string().required('Task Groups is required'),
    task: Yup.string().required('Task is required')
});

const MappingForm = (props) => {
    const { id } = useParams()
    // State declarations
    const [properties, setProperties] = useState([]);
    const [roomTypes, setRoomTypes] = useState([]);
    const [workStages, setWorkStages] = useState([]);
    const [taskProcesses, setTaskProcesses] = useState([]);
    const [taskGroups, setTaskGroups] = useState([]);
    const [tasks, setTasks] = useState([]);
    const navigate = useNavigate()
    let selectedDataHkt = JSON.parse(localStorage.getItem('edit-manage-hkt')) || {}
    const selectedProperty = JSON.parse(localStorage?.getItem('selectedProperty')) || {}
    // Formik form handling
    const formik = useFormik({
        initialValues: {
            property: '',
            roomType: '',
            workStages: '',
            taskProcess: '',
            taskGroups: '',
            task: ''
        },
        validationSchema: validationSchema,
        onSubmit: values => {
            props.handleAction(values)
            // formik.resetForm()
        },
    });

    // Fetch properties
    const getProperties = async () => {
        try {
            const response = await nbrApi.post('/listproperties');

            const data = response.data;
            setProperties(data?.map(e => ({
                ...e,
                value: e?.pk_id,
                label: e?.property_name
            })));
        } catch (error) {
            console.error('Error fetching data:', error.message);
        }
    };

    // Fetch room types by property ID
    const getRoomsByPropertyID = async (id = null) => {
        setRoomTypes([]);
        try {
            const response = await nbrApi.get(`/getroomtypes?properties_id=${id ? id : formik.values.property}`);

            const data = response.data;
            setRoomTypes(data?.map(e => ({
                ...e,
                value: e?.rt_id,
                label: e?.room_type_name
            })));
            formik.setFieldValue("roomType", '');

        } catch (error) {
            console.error('Error fetching data:', error.message);
        }
    };

    // Fetch work stages by property ID
    const getWorkSegmentsID = async (id = null) => {
        setWorkStages([]);
        formik.setFieldValue("workStages", '')
        try {
            const response = await nbrApi.get(`/getworksegments?properties_id=${id ? id : formik.values.property}`);

            const data = response.data;
            setWorkStages(data?.map(e => ({
                ...e,
                value: e?.ws_id,
                label: e?.segment_name
            })));
        } catch (error) {
            console.error('Error fetching data:', error.message);
        }
    };

    // Fetch task processes by property ID and work stage ID
    const getTaskProcessList = async () => {
        setTaskProcesses([])
        formik.setFieldValue("taskProcess", '')
        try {
            const response = await nbrApi.get(`/gettaskprocesses?properties_id=${formik.values.property}&worksegments_id=${formik.values.workStages}`);

            const data = response.data;
            setTaskProcesses(data?.map(e => ({
                ...e,
                value: e?.tp_id,
                label: e?.process_name
            })));
        } catch (error) {
            console.error('Error fetching data:', error.message);
        }
    };

    // Fetch task groups by property ID and task process ID
    const getTaskGroupsList = async () => {
        setTaskGroups([])
        formik.setFieldValue("taskGroups", '')
        try {
            const response = await nbrApi.get(`/gettaskgroups?properties_id=${formik.values.property}&tp_id=${formik.values.taskProcess}`);

            const data = response.data;
            setTaskGroups(data?.map(e => ({
                ...e,
                value: e?.tg_id,
                label: e?.task_group_name
            })));
        } catch (error) {
            console.error('Error fetching data:', error.message);
        }
    };

    // Fetch tasks by property ID and room type ID
    const getTasksList = async () => {
        setTasks([])
        formik.setFieldValue("task", '')
        try {
            const response = await nbrApi.get(`/getmriritbytt?properties_id=${formik.values.property}&rt_id=${formik.values.roomType}`);

            const data = response.data;
            setTasks(data?.map(e => ({
                ...e,
                value: e?.mririt_id,
                label: e?.rit_ri_name
            })));
        } catch (error) {
            console.error('Error fetching data:', error.message);
        }
    };

    // Fetch properties on component mount
    useEffect(() => {
        if (properties.length === 0) {
            getProperties();
        }
    }, []);

    // Fetch related data whenever property, work stage, task process, or room type changes
    useEffect(() => {
        if (!id) {
            if (formik.values.property) {
                getRoomsByPropertyID();
                getWorkSegmentsID();
            }
        } else {
            if (formik.values.property) {
                getRoomsByPropertyID();
                getWorkSegmentsID();
            }
        }
    }, [formik.values.property]);

    useEffect(() => {
        if (formik.values.property && formik.values.workStages) {
            getTaskProcessList();
        }
    }, [formik.values.property, formik.values.workStages]);

    useEffect(() => {
        if (formik.values.property && formik.values.taskProcess) {
            getTaskGroupsList();
        }
    }, [formik.values.property, formik.values.taskProcess]);

    useEffect(() => {
        if (formik.values.property && formik.values.roomType) {
            getTasksList();
        }
    }, [formik.values.property, formik.values.roomType]);

    // store in local store
    useEffect(() => {
        let data = formik.values
        localStorage.setItem('edit-mapping-default', JSON.stringify(data))

        // let editMappingData = JSON.parse(localStorage.getItem('edit-mapping-default')) || {}
        // let existingData = {}
        // if(editMappingData){
        //     existingData = editMappingData
        // }
        // const dataToStore = {
        //     mhkt_id: formik.values.property,
        //     sequence: existingData?.sequence, 
        //     mririt_id: formik.values.task,
        //     ws_id: formik.values.workStages,
        //     segment_name: workStages.find(option => option.value === formik.values.workStages)?.label || '', // Assuming workStages is an array of objects with value and label properties
        //     tp_id: formik.values.taskProcess,
        //     process_name: taskProcesses.find(option => option.value === formik.values.taskProcess)?.label || '', // Assuming taskProcesses is an array of objects with value and label properties
        //     tg_id: formik.values.taskGroups,
        //     task_group_name: taskGroups.find(option => option.value === formik.values.taskGroups)?.label || '', // Assuming taskGroups is an array of objects with value and label properties
        //     item_task_name: tasks.find(option => option.value === formik.values.task)?.label || '', // Placeholder for item task name
        //     item_name: '', // Placeholder for item name
        //     rity_id: existingData?.rity_id, // Placeholder for rity id
        //     rity_name: existingData?.rity_name, // Placeholder for rity name
        //     rt_id: formik.values.roomType,
        //     room_type_name: roomTypes.find(option => option.value === formik.values.roomType)?.label || '' // Assuming roomTypes is an array of objects with value and label properties
        // };
        // console.log(dataToStore)

        // localStorage.setItem('edit-mapping-default', JSON.stringify(dataToStore));
    }, [formik.values])


    useEffect(() => {
        // console.log(formik.values)
        // const { rt_id, ws_id, tp_id, tg_id, mririt_id } = props.selectedItem;
        if (id && properties?.length > 0 && !formik.values.property) {
            formik.setFieldValue('property', selectedProperty?.value)
            getRoomsByPropertyID(selectedProperty?.value);
            getWorkSegmentsID(selectedProperty?.value);
        }
        if (id && roomTypes?.length > 0 && !formik.values.roomType) {
            formik.setFieldValue('roomType', selectedDataHkt?.rt_id)
        }
        if (id && workStages?.length > 0 && !formik.values.workStages) {
            formik.setFieldValue('workStages', selectedDataHkt?.ws_id)
        }
        if (id && taskProcesses?.length > 0 && !formik.values.taskProcess) {
            formik.setFieldValue('taskProcess', selectedDataHkt?.tp_id)
        }
        if (id && taskGroups?.length > 0 && !formik.values.taskGroups) {
            formik.setFieldValue('taskGroups', selectedDataHkt?.tg_id)
        }
        if (id && tasks?.length > 0 && !formik.values.task) {
            formik.setFieldValue('task', selectedDataHkt?.mririt_id)
        }
    }, [id, formik])

    // render
    return (
        <form onSubmit={formik.handleSubmit}>
            <div className="row">
                <div className="form-group mb-3">
                    <label className="m-1 text-black" htmlFor="property">Property:</label>
                    <Select
                        className="form-control p-0"
                        options={properties}
                        id="property"
                        onChange={(selectedOption) => formik.setFieldValue("property", selectedOption.value)}
                        value={properties.find(option => option.value === formik.values.property) || {}}
                    />
                    {formik.errors.property && formik.touched.property && (
                        <div className="text-danger mt-3">{formik.errors.property}</div>
                    )}
                </div>
                <div className="form-group mb-3">
                    <label className="m-1 text-black" htmlFor="roomType">Room Type:</label>
                    <Select
                        className="form-control p-0"
                        options={roomTypes}
                        id="roomType"
                        onChange={(selectedOption) => formik.setFieldValue("roomType", selectedOption.value)}
                        value={roomTypes.find(option => option.value === formik.values.roomType) || {}}
                    />
                    {formik.errors.roomType && formik.touched.roomType && (
                        <div className="text-danger mt-3">{formik.errors.roomType}</div>
                    )}
                </div>
                <div className="form-group mb-3">
                    <label className="m-1 text-black" htmlFor="workStages">Work Stages:</label>
                    <Select
                        className="form-control p-0"
                        options={workStages}
                        id="workStages"
                        onChange={(selectedOption) => formik.setFieldValue("workStages", selectedOption.value)}
                        value={workStages.find(option => option.value === formik.values.workStages) || {}}
                    />
                    {formik.errors.workStages && formik.touched.workStages && (
                        <div className="text-danger mt-3">{formik.errors.workStages}</div>
                    )}
                </div>
                <div className="form-group mb-3">
                    <label className="m-1 text-black" htmlFor="taskProcess">Task Process:</label>
                    <Select
                        className="form-control p-0"
                        options={taskProcesses}
                        id="taskProcess"
                        onChange={(selectedOption) => formik.setFieldValue("taskProcess", selectedOption.value)}
                        value={taskProcesses.find(option => option.value === formik.values.taskProcess) || {}}
                    />
                    {formik.errors.taskProcess && formik.touched.taskProcess && (
                        <div className="text-danger mt-3">{formik.errors.taskProcess}</div>
                    )}
                </div>
                <div className="form-group mb-3">
                    <label className="m-1 text-black" htmlFor="taskGroups">Task Groups:</label>
                    <Select
                        className="form-control p-0"
                        options={taskGroups}
                        id="taskGroups"
                        onChange={(selectedOption) => formik.setFieldValue("taskGroups", selectedOption.value)}
                        value={taskGroups.find(option => option.value === formik.values.taskGroups) || {}}
                    />
                    {formik.errors.taskGroups && formik.touched.taskGroups && (
                        <div className="text-danger mt-3">{formik.errors.taskGroups}</div>
                    )}
                </div>
                <div className="form-group mb-3">
                    <label className="m-1 text-black" htmlFor="task">Task:</label>
                    <div className='d-flex'>
                        <Select
                            className="form-control p-0"
                            options={tasks}
                            id="task"
                            onChange={(selectedOption) => formik.setFieldValue("task", selectedOption.value) || {}}
                            value={tasks.find(option => option.value === formik.values.task) || {}}
                        />
                        <button type='button' className='btn btn-outline-secondary mx-2'
                            onClick={() => navigate(formik.values.task ?
                                '/room-item-mapper/edit/' + formik.values.task
                                : '/room-item-mapper/create')}><i className='fa fa-edit fs-5' /></button>
                    </div>

                    {formik.errors.task && formik.touched.task && (
                        <div className="text-danger mt-3">{formik.errors.task}</div>
                    )}
                </div>
            </div>
            <button type="submit" className="btn btn-primary">Submit</button>
        </form>
    );
};


export default MappingForm